import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

// We also pass queued price and product fields, because when quantity is set to zero,
// it is possible that these fields are also updated, if price or product are queued on next empty.

const MODIFY_PLANOGRAM_ITEM_QUANTITY = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

export default MODIFY_PLANOGRAM_ITEM_QUANTITY;


